var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_NavIcon_VerNet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_NavIcon_VerNet_2",
    clipPath: "url(#clip0_1773_80926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.32 3H4.5C4.22386 3 4 3.22386 4 3.5V13.75C4 14.0261 4.22386 14.25 4.5 14.25H10.32C10.5961 14.25 10.82 14.0261 10.82 13.75V3.5C10.82 3.22386 10.5961 3 10.32 3Z",
    fill: "#8F91A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.65 16.25H4.5C4.22386 16.25 4 16.4739 4 16.75V19.54C4 19.8161 4.22386 20.04 4.5 20.04H10.65C10.9261 20.04 11.15 19.8161 11.15 19.54V16.75C11.15 16.4739 10.9261 16.25 10.65 16.25Z",
    fill: "#8F91A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.0603 3H13.3203C13.0442 3 12.8203 3.22386 12.8203 3.5V7.44C12.8203 7.71614 13.0442 7.94 13.3203 7.94H19.0603C19.3365 7.94 19.5603 7.71614 19.5603 7.44V3.5C19.5603 3.22386 19.3365 3 19.0603 3Z",
    fill: "#8F91A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.0603 9.93945H13.3203C13.0442 9.93945 12.8203 10.1633 12.8203 10.4395V19.5395C12.8203 19.8156 13.0442 20.0395 13.3203 20.0395H19.0603C19.3365 20.0395 19.5603 19.8156 19.5603 19.5395V10.4395C19.5603 10.1633 19.3365 9.93945 19.0603 9.93945Z",
    fill: "#8F91A1"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1773_80926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.56,
    height: 17.04,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.7fbc39a10f6899e6fb814aaf547de9a4.svg";
export { ForwardRef as ReactComponent };